{
    "name": "Pink Oyster Mushroom",
    "binomial_name": "Pleurotus djamor",
    "common_names": [],
    "description": "Pink Oyster mushrooms are a member of the Oyster family whose mycelium are more susceptible to infection and competition. This makes them more difficult to grow, and they benefit from sterilized substrate. They can grow at room temperature and anywhere warmer.",
    "sun_requirements": "Partial Sun",
    "sowing_method": "Inoculate substrate with spores",
    "spread": 0,
    "row_spacing": 0,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "",
    "icon": "/crops/icons/pink-oyster-mushroom.avif"
}